module.exports = "//static.hsappstatic.net/LoginUI/static-1.16060/img/hubspotMobileApp2FA.png"